import makeStyles from '@mui/styles/makeStyles';
import React, {useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import {getQueryString} from "../utils/http-helpers";
import {Button} from "@mui/material";
import {Refresh, Search} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    certSearchActions: {
        display: "flex",
        gap: "5px",
    },
}));

export default function OrganizationUsersSearchPanel(props) {
    const classes = useStyles();
    const onQueryStringChanged = props.onQueryStringChanged;
    const showOrgContact = props.showOrgContact === undefined ? false  : props.showOrgContact;
    const onRefresh = props.onRefresh;

    const [params, setParams] = useState({});
    const [queryString, setQueryString] = useState("");

    useEffect(() => {
        console.log('useEffect, queryString updated: ', queryString);
        onQueryStringChanged(queryString);
    }, [queryString]);

    const search = () => {
        const s = getQueryString(params);
        console.log('search', params, s);
        setQueryString(s);

        // setQueryString(getQueryString(params));
    }
    const refresh = () => {
        onRefresh( new Date().getTime() );
    }
    const handleFormFieldChanged = (name, value) => {
        // params[name] = value;
        const newParams = {...params};
        if (value === undefined){
            if (newParams[name] !== undefined){
                delete newParams[name];
            }
        } else {
            newParams[name] = value;
        }
        setParams(newParams);
    }
    const handleResetForm = () => {
        setParams({})
        setQueryString(getQueryString({}));
    }
    const handleFormKeypress = (e) => {
        if (e.key === "Enter"){
            search();
        }
    }

    return (
        <form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <div>
                <TextField variant="standard" size="small" style={{marginLeft: 0}} label="User First Name" type="search" defaultValue={params.givenName || ""} onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged("givenNameLike", e.target.value)} />
                <TextField variant="standard" size="small" label="User Last Name" type="search" defaultValue={params.familyName || ""} onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged("familyNameLike", e.target.value)} />

            </div>
            <div className={classes.certSearchActions}>
                <Button variant="contained" color={"primary"} onClick={() => search()} > <Search /> Search </Button>
                <Button variant={"outlined"} color={"primary"} onClick={() => refresh()} > <Refresh /> Refresh </Button>
                <Button variant={"outlined"} color={"primary"} onClick={() => handleResetForm() } > Reset </Button>
            </div>

        </form>
    )
}
